import React, { useEffect, useState } from "react";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import {
  getAllSubscriptionRequestById,
  updateSubcriptionStatus,
} from "../../Actions/actions";
import Loader from "../../Components/Loader/Loader";
import AuthButton from "../../Components/AuthButton/AuthButton";
import { subscriptionColors } from "../../Reducers/reducers";



function ClientDetails() {
  const dispatch = useDispatch();
  const location = useLocation();

  const { id } = location.state;

  const { loginData, loader } = useSelector((state) => state.userReducer);
  const [clientData, setClientData] = useState(null);

  const [status, setStatus] = useState(null);
  const [headCount, setHeadCount] = useState(null);

  useEffect(() => {
    if (id && loginData?.accessToken) {
      dispatch(
        getAllSubscriptionRequestById(loginData.accessToken, id, (response) => {
          setClientData(response.data);
          setStatus(response.data.status);
          setHeadCount(response.data.salesTeamHeadcount);
        })
      );
    }
  }, [id, loginData]);

  const handleUpdate = () => {
    const payload = {
      status: status,
      salesTeamHeadcount: headCount,
    };

    dispatch(
      updateSubcriptionStatus(
        loginData.accessToken,
        payload,
        id,
        (response) => {
          setStatus(response.data.status);
          setHeadCount(response.data.salesTeamHeadcount);
        }
      )
    );
  };

  if (!clientData) return <div className="p-6">Loading...</div>;

  return (
    <ParentComponent>
      <PrimaryHeader />

      <div className="bg-white shadow-md rounded-lg p-6 border">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">
          Client Details
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <p className="text-sm font-semibold text-gray-800">Name</p>
            <p className="text-gray-600 font-regular text-sm">
              {clientData?.name}
            </p>

            <p className="text-sm font-semibold text-gray-800 mt-4">
              Phone Number
            </p>
            <p className="text-gray-700 text-sm">{clientData?.phoneNumber}</p>

            <p className="text-sm font-semibold mt-4">
              Subscription Package Request for
            </p>
            <div className="flex">
              <p
                className={`text-gray-700 font-regular text-sm py-1 mt-1 rounded-md px-4 ${
                  subscriptionColors[clientData?.package]
                }`}
              >
                {clientData?.package}
              </p>
            </div>
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-800">Company Name</p>
            <p className="text-gray-600 font-regular text-sm">
              {clientData?.company}
            </p>
            <p className="text-gray-400 font-regular text-sm">
              {clientData?.email}
            </p>

            <p className="text-sm font-semibold text-gray-800 mt-4">Industry</p>
            <p className="text-gray-700 text-sm font-regular">
              {clientData?.industry || "N/A"}
            </p>

            <p className="text-sm font-semibold text-gray-800 mt-4">Message</p>
            <p className="text-gray-700 text-sm font-regular">
              {clientData?.message || "N/A"}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div>
            <p className="text-sm font-semibold text-gray-800">Status</p>
            <select
              className="w-full border border-gray-300 rounded-md p-2 mt-1 bg-white focus:ring focus:ring-indigo-200"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option>Not Contacted</option>
              <option>Contacted</option>
              <option>Demo Done</option>
              <option>Subscribed</option>
              <option>Demo Scheduled</option>
            </select>
          </div>

          <div>
            <p className="text-sm font-semibold text-gray-800">Head Count</p>
            <select
              className="w-full border border-gray-300 rounded-md p-2 mt-1 bg-white focus:ring focus:ring-indigo-200"
              value={headCount}
              onChange={(e) => setHeadCount(e.target.value)}
            >
              <option>1-10</option>
              <option>10-50</option>
              <option>50-100</option>
              <option>100+</option>
            </select>
          </div>
        </div>
        <div className="flex justify-end mt-10 ">
          {loader ? (
            <Loader />
          ) : (
            <AuthButton
              title={"Save Changes"}
              className="text-white rounded-md"
              onClick={() => handleUpdate()}
            />
          )}
        </div>
      </div>
    </ParentComponent>
  );
}

export default ClientDetails;
